import { useNavigate } from "react-router-dom";
import { LogOut, Shield, User as UserIcon, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function UserMenu() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (!user || user === false || user === null) return null;

  const isAdmin = user.role === "admin";
  const initial = (user.name || user.email || "?").charAt(0).toUpperCase();

  const handleLogout = async () => {
    await logout();
    toast.success("Signed out");
    // Hard navigation so we land on the Landing page instead of
    // ProtectedRoute bouncing us to /auth first.
    window.location.href = "/";
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-trigger"
          className="flex items-center gap-2 rounded-lg border border-black/[0.08] hover:border-black/[0.2] bg-white h-9 pl-1.5 pr-2 transition-colors"
          aria-label="Account menu"
        >
          {user.picture ? (
            <img
              src={user.picture}
              alt=""
              className="w-6 h-6 rounded-full object-cover"
            />
          ) : (
            <div className="w-6 h-6 rounded-full bg-sage-100 border border-sage-200 grid place-items-center text-sage-700 text-[11px] font-medium">
              {initial}
            </div>
          )}
          <span className="text-xs text-[#1C1C1C] font-medium hidden sm:inline max-w-[120px] truncate">
            {user.name || user.email}
          </span>
          <ChevronDown className="w-3 h-3 text-[#A8A29E]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-white border-black/[0.08]">
        <DropdownMenuLabel className="text-[#1C1C1C]">
          <div className="text-sm font-medium truncate">{user.name || "Account"}</div>
          <div className="text-[11px] text-[#78716C] font-normal truncate">{user.email}</div>
          <div className="mt-1.5 inline-flex text-[10px] uppercase tracking-[0.15em] px-1.5 py-0.5 rounded-full bg-sage-50 text-sage-700 border border-sage-200">
            {user.plan || "free"} plan
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => navigate("/admin")}
            data-testid="user-menu-admin"
            className="cursor-pointer"
          >
            <Shield className="w-4 h-4 mr-2" /> Admin dashboard
          </DropdownMenuItem>
        )}
        <DropdownMenuItem disabled className="text-[#A8A29E]">
          <UserIcon className="w-4 h-4 mr-2" /> Profile (coming soon)
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleLogout}
          data-testid="user-menu-logout"
          className="cursor-pointer text-[#DC2626] focus:text-[#DC2626]"
        >
          <LogOut className="w-4 h-4 mr-2" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
